import Service from '@ember/service';
import { action, set } from '@ember/object';
import { getOwner } from '@ember/application';

export default class ThemeService extends Service {
  get isDark() {
    return localStorage.getItem('theme') === 'dark';
  }

  set isDark(value) {
    localStorage.setItem('theme', value ? 'dark' : 'light');
    document.documentElement.setAttribute('data-theme', value ? this.darkTheme : this.lightTheme);
  }

  get #config() {
    return getOwner(this).resolveRegistration('config:environment').APP;
  }

  get lightTheme() {
    return this.#config.lightTheme ?? 'pds-witsmlstudio-light';
  }

  get darkTheme() {
    return this.#config.darkTheme ?? 'pds-witsmlstudio-dark';
  }

  constructor() {
    super(...arguments);
    this.isDark = this.isDark;
  }

  @action
  toggle() {
    set(this, 'isDark', !this.isDark);
  }
}
